import React from "react";
import { Link } from "react-router-dom";

function NotFound() {
  return (
    <div
      style={{
        minHeight: "calc(100vh - 60px)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "2rem",
        flexDirection: "column",
      }}
    >
      {/* A better 404 error page but can't use it unfortunately */}
      {/* <img width="600" src="https://a.pinatafarm.com/2000x1124/b177c50844/guy-confused.jpg" alt="Where do you think you're going?" />
      <h1 style={{ margin: "0" }}>Where do you think you&apos;re going?</h1> */}
      <h1>We think you made a wrong turn somewhere</h1>
      <h2>
        Back to <Link to="/">Home</Link>
      </h2>
    </div>
  );
}

export default NotFound;
